import styled from 'styled-components';

const Message = styled.div`
    background-color: #4670e8;
    padding: 1rem 2rem;
    color: #fff;
`

export default Message;